import { render } from "./ProAvulsosporCestasView.vue?vue&type=template&id=35153766&scoped=true"
import script from "./ProAvulsosporCestasView.vue?vue&type=script&lang=js"
export * from "./ProAvulsosporCestasView.vue?vue&type=script&lang=js"

import "./ProAvulsosporCestasView.vue?vue&type=style&index=0&id=35153766&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35153766"]])

export default __exports__